'use strict';

angular.module('shiftTraderApp')
  .controller('TradesCtrl', function ($scope, ShiftTradesResource, trades, me, TimeService) {
    $scope.me = me;
    $scope.trades = _.invoke(trades, '$initialize');

    $scope.showSelector = 'true'; // show active trades first

    //sort trades by
    // first by open, accepted, approved, then declined/disapproved
    // second ascending min(wp.start_time, trade_wp.start_time)

    var sortOrder = [
      0,  // open (no status)
      10, // accepted
      20, // approved
      21, // disapproved
      11  // rejected
    ];

    var calculateActiveState = function() {
      $scope.activeTrades = [];
      $scope.inactiveTrades = [];
      $scope.shiftTrades = [];
      $scope.myShiftTrades = [];

      // strategy for sorting
      //  for each trade status in sortOrder
      //   filter for the trade status, sort by min start time, push those onto $scope.shiftTrades
      angular.forEach(sortOrder, function (tradeStatus) {
        var tradesWithXStatus = _.filter($scope.trades, function (trade) {
          return trade.$currentStatus() === tradeStatus;
        });

        var items = _.sortBy(tradesWithXStatus, function (trade) {
          var wpStart = moment(trade.work_period.start_time).unix();
          var tradeWpStartTime;
          if (trade.trade_work_period !== null) {
            tradeWpStartTime = moment(trade.trade_work_period.start_time).unix();
          } else {
            tradeWpStartTime = 99999999999999999;
          }
          return -1 * Math.min(wpStart, tradeWpStartTime);
        });
        //console.log(items);


        angular.forEach(items, function (i) {
          $scope.shiftTrades.push(i);

          if (i.user.id === me.id ||
            (i.trade_user && i.trade_user.id === me.id) ||
            (i.$isGiveaway() &&
              _.any(i.shift_trade_responses, function(resp) {
                if (_.has(resp, 'user_id')) {
                  return resp.acceptance_code === 10 && me.id === resp.user_id;
                } else {
                  return resp.acceptance_code === 10 && me.id === resp.user.id;
                }
              }))) {
            $scope.myShiftTrades.push(i);
          }
        });
      });
      //console.log($scope.myShiftTrades);

      angular.forEach($scope.myShiftTrades, function(trade) {
        if (trade.$calculateActive(true)) {
          $scope.activeTrades.push(trade);
        } else {
          $scope.inactiveTrades.push(trade);
        }
      });


    };

    calculateActiveState();
    $scope.selectedTrades = $scope.activeTrades;
    var queryData = {
      active: false,
      user_id: $scope.me.id,
      start_date: TimeService.getBeginningOfDayFromDate(moment()).subtract(3, 'months').format()
    };

    ShiftTradesResource.query(queryData, function(data) {
      $scope.trades.push.apply($scope.trades, _.invoke(data, '$initialize'));
      calculateActiveState();
    });

    $scope.setShow = function(val) {
      $scope.showSelector = val;
      if (val === 'true') {
        $scope.selectedTrades = $scope.activeTrades;
      } else {
        $scope.selectedTrades = $scope.inactiveTrades;
      }
    };
  });
